import { NioApmPlus } from '@nio-fe/nio-apm-plus'
import {  getEnv, getFellowName, isTpad } from '@common/utils'
import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid';
import { reportType } from './types'


// 全局错误捕获
export const globalErrorCatch = () => {
  window.onunhandledrejection = function (event) {
    if(event?.reason?.fromType === 'unity'){
      reportAmpLog({ key: 'unityMessageError', value: event }, reportType.Error)
      return false
    }
  }
}
export const createApmInstance = () => {
  const release = configProcess.env.VITE_BUILD_RELEASE || 'local.1.0';
  console.log('---release---',release);
    const params = {
      aid: 1110425156,
      token: '56fc387bca7d4ec88fe2a9d3098ff9ef',
      env: getEnv(),
      release: release,
      plugins: {
        blankScreen: {
          rootSelector: '#app',
          threshold: 2.5,
          screenshot: true,
        },
        // vue 应用开启捕获 Vue.config.errorHandler
        vueErrorHandler: {
          app: Vue,
        },
        performance: true,
      },
    }
    let user_id = ''
    // 是pad的话从pad上面拿到用户信息，不是的话生成UUID，pad也只能拿到fellow_name
    if (isTpad) {
      let fellow_name = getFellowName()
      fellow_name && (user_id = fellow_name)
    }
    if (!user_id) {
      if (localStorage.getItem('custom_uuid')) {
        user_id = localStorage.getItem('custom_uuid') || ''
      } else {
        user_id = uuidv4() || ''
        localStorage.setItem('custom_uuid', user_id)
      }
    }
    if (user_id) {
      params.userId = user_id
    }
    NioApmPlus.createDefaultInstance(params).then((instance) => {
      instance.mergeContext({
        'platform_type' : isTpad ? 'nio_pad' : 'nio_pc'
      })
    })
  }
  export const reportAmpLog = (
    info = {
      key: '',
      value: {}
    },
    type = reportType
  ) => {
    const commonParams = {}
    const params = {
      ...commonParams,
      ...info.value
    }
    switch (type) {
      case reportType.Error:
        NioApmPlus.getDefaultInstance()?.error?.(
          `${info.key}:${JSON.stringify(params)}`
        )
        break
      case reportType.Info:
        NioApmPlus.getDefaultInstance()?.info?.(info.key, params?? {})
        break
      case reportType.Warn:
        NioApmPlus.getDefaultInstance()?.warn?.(`${info.key}:${JSON.stringify(params)}`)
        break
      case reportType.Debug:
        break
  
      default:
        break
    }
  }